import { PREDES_TRANSACTIONS_EDIT_REQUEST, PREDES_TRANSACTIONS_EDIT_SUCCESS, PREDES_TRANSACTIONS_EDIT_FAILURE } from './types/PredesTransactionsEditActionTypes';

export function putPredesTransactionsEditRequestActionCreator(context,
  newComments,
  newDepartureDateTime,
  newImpcFrom,
  newImpcTo,
  newOperatorFrom,
  newOperatorTo,
  newPlannedArrivalDateTime,
  newQuantity,
  newTransactionId) {
  return {
    type: PREDES_TRANSACTIONS_EDIT_REQUEST,
    payload: {
      appContext: context,
      params: {
        comments: newComments,
        departureDateTime: newDepartureDateTime,
        impcFrom: newImpcFrom,
        impcTo: newImpcTo,
        operatorFrom: newOperatorFrom,
        operatorTo: newOperatorTo,
        plannedArrivalDateTime: newPlannedArrivalDateTime,
        quantity: newQuantity,
        transactionId: newTransactionId,
      },
    },
  };
}

export function putPredesTransactionsEditSuccessActionCreator(data) {
  return {
    type: PREDES_TRANSACTIONS_EDIT_SUCCESS,
    payload: data,
  };
}

export function putPredesTransactionsEditFailureActionCreator(error) {
  return {
    type: PREDES_TRANSACTIONS_EDIT_FAILURE,
    payload: error,
    error: true,
  };
}
